"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Favorites = void 0;
var _favoritesHeart = require("@ori/favorites-heart");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _constants = require("../../constants");
var _useTranslations = require("../../hooks/useTranslations");
var _jsxRuntime = require("react/jsx-runtime");
const Favorites = ({
  analyticsData,
  code,
  disabled,
  productListId,
  onFavoritesButtonClick,
  shades
}) => {
  const {
    translations
  } = (0, _useTranslations.useTranslations)();
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_favoritesHeart.FavoritesHeartIconButton, {
    "aria-label": translations.favorites,
    code: code,
    "data-testid": `${getTestId(_constants.FAVORITE)}-${code}`,
    disabled: disabled,
    placement: analyticsData?.placement,
    position: analyticsData?.position,
    shades: shades,
    size: "medium",
    desktopSize: "large",
    productListId: productListId,
    onClick: onFavoritesButtonClick
  });
};
exports.Favorites = Favorites;
var _default = exports.default = Favorites;
